import { useLayoutEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import ReactModal from 'react-modal';
import Button from 'components/Button/Button';
import { IconX } from 'components/icons';
import styles from './Modal.module.scss';
import { getEnvironment } from 'utils/environment';

export type ModalProps = ReactModal.Props;

// Reset default inline styles, Tailwind classes will be used
ReactModal.defaultStyles = {};

export default function Modal(props: ModalProps) {
  const appElement = useMemo(
    () => document.getElementById('root') || undefined,
    []
  );

  // After component is rendered -> animations are trigged
  const [visible, setVisible] = useState(false);

  useLayoutEffect(() => {
    // Push to back of event queue
    setTimeout(() => {
      // Set/Reset visible (rendered) state based on isOpen
      // Reset must be done because component can be still rendered, only isOpen is false
      setVisible(props.isOpen);
    });
  }, [props.isOpen]);

  return (
    <ReactModal
      ariaHideApp={getEnvironment() !== 'test'}
      appElement={appElement}
      preventScroll
      {...props}
      overlayClassName={classNames(
        'fixed top-0 flex items-end md:items-center justify-center w-screen h-full z-50 inset-0 bottom bg-gray-900',
        // animations
        'md:bg-opacity-50 md:transition-none transition duration-200 ease-in-out',
        { 'bg-opacity-0': !visible },
        { 'bg-opacity-50': visible }
      )}
      className={classNames(
        'px-4 sm:px-6 pt-3 pb-6 md:pb-7 bg-white w-full md:w-11/12 h-auto md:max-w-lg mx-auto rounded-b-none md:rounded-b-lg rounded-lg shadow-lg z-50 overflow-y-auto',
        'md:translate-y-0 transition duration-300 ease-in-out', // animations
        { 'translate-y-full': !visible },
        styles.wrapper
      )}
    >
      <div className="relative text-right -mr-3 sm:-mr-5 h-[40px]">
        <Button
          size="small"
          showAsIcon
          onClick={props.onRequestClose || (() => {})}
        >
          <IconX width={24} />
        </Button>
      </div>
      <div>{props.children}</div>
    </ReactModal>
  );
}
